export default {
  orgActivity: {
    title: "Activity",
    subtitle: "Who did what in your organization.",
    export: "Export CSV",
    retentionNote: "Showing the last {days} days. Full history is available on the PRO and ULTRA plans.",
    allActions: "All actions",
    from: "From",
    to: "To",
    clear: "Clear",
    loading: "Loading…",
    empty: "No activity recorded in your organization yet.",
    emptyFilters: "No activity matching the current filters.",
    eventsCount: "{n} events",
    colDateTime: "Date/Time",
    colUser: "User",
    colAction: "Action",
    colDetail: "Detail",
    colIp: "IP",
    prev: "← Previous",
    next: "Next →",
    pageOf: "Page {page} of {total}",
  },
};
